module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("gWFFW"))).then(() => module.bundle.root('1iHdE'));